import React, { FC } from 'react';
import config from '@src/config/config';
import './styles.scss';

export const PublicOpenings: FC = () => {
  return <iframe className="public-openings" src={`${config.publicOpeningsUrl}?iframe=employer`}></iframe>;
};
